import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';

import style from './style.module.less';
import { INPUT_KEYS } from '../constants';
import messages from '../messages';

const AddressSection = ({
  address,
  hasCompany = false,
  company = '',
  onChange = noop,
  firstName = '',
  lastName = '',
  isDisabled = false,
}) => {
  const renderAddress = () => {
    if (hasCompany) {
      return (
        <div className={style.address}>
          {company}
          <br />
          {address.line1}
          <br />
          {address.line2 ? <div>{address.line2}</div> : null}
          {address.line3 ? <div>{address.line3}</div> : null}
        </div>
      );
    }
    return (
      <>
        <div className={style.label}>
          <FormattedMessage {...messages.companyPickupLabel} />
        </div>
        <div>
          <Input className={style['address-input']} id='company' onChange={onChange(INPUT_KEYS.COMPANY)} value={company} />
        </div>
        <div className={style.address}>
          {address.line1}
          <br />
          {address.line2 ? <div>{address.line2}</div> : null}
          {address.line3 ? <div>{address.line3}</div> : null}
        </div>
      </>
    );
  };

  if (isDisabled) {
    return (
      <div className={style['static-address']}>
        {`${firstName} ${lastName}`}
        <br />
        {company}
        <br />
        {address.line1}
        <br />
        {address.line2 ? <div>{address.line2}</div> : null}
        {address.line3 ? <div>{address.line3}</div> : null}
      </div>
    );
  }

  return (
    <>
      <div className={style.label}>
        <FormattedMessage {...messages.firstNamePickupLabel} />
      </div>
      <div>
        <Input className={style['address-input']} onChange={onChange(INPUT_KEYS.FIRST_NAME)} value={firstName} />
      </div>
      <div className={style.label}>
        <FormattedMessage {...messages.lastNamePickupLabel} />
      </div>
      <div>
        <Input className={style['address-input']} onChange={onChange(INPUT_KEYS.LAST_NAME)} value={lastName} />
      </div>
      {renderAddress()}
    </>
  );
};

AddressSection.propTypes = {
  address: PropTypes.object.isRequired,
  hasCompany: PropTypes.bool,
  company: PropTypes.string,
  onChange: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default AddressSection;
